var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 81,
    viewBox: "0 0 140 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 22.0528C69.23 20.0489 67.5344 18.3533 65.5306 18.3533H19.2878C17.2839 18.3533 15.5884 20.0489 15.5884 22.0528C15.5884 24.0566 17.2839 25.7522 19.2878 25.7522H65.5306C67.6885 25.7522 69.23 24.0566 69.23 22.0528Z",
    fill: "url(#paint0_linear_256_20035)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2181 39.7792C63.2181 37.7753 61.5225 36.0797 59.5187 36.0797H35.1642C33.1603 36.0797 31.4647 37.7753 31.4647 39.7792C31.4647 41.783 33.1603 43.4786 35.1642 43.4786H59.5187C61.6767 43.4786 63.2181 41.783 63.2181 39.7792Z",
    fill: "url(#paint1_linear_256_20035)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4416 0.626953H4.33565C2.3318 0.626953 0.63623 2.32252 0.63623 4.32637C0.63623 6.33023 2.3318 8.0258 4.33565 8.0258H99.5958C117.63 8.0258 132.12 22.6693 132.12 40.5499C132.12 58.4304 117.476 73.074 99.5958 73.074C87.4185 73.074 76.3202 66.2917 70.617 55.5017C70.0004 54.2686 68.7672 53.4979 67.38 53.4979H48.4204C46.4166 53.4979 44.721 55.1934 44.721 57.1973C44.721 59.2011 46.4166 60.8967 48.4204 60.8967H65.0678C72.1584 73.074 85.2605 80.627 99.4416 80.627C121.484 80.4728 139.365 62.5923 139.365 40.5499C139.365 18.5075 121.484 0.626953 99.4416 0.626953Z",
    fill: "url(#paint2_linear_256_20035)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4416 14.4998C97.2836 14.4998 95.4339 16.3495 95.4339 18.5075V41.3206C95.4339 41.6289 95.4339 41.783 95.4339 42.0913C95.4339 42.3996 95.5881 42.5537 95.5881 42.862C95.7422 43.0162 95.7422 43.3245 95.8963 43.4786C96.0505 43.6327 96.2046 43.941 96.3588 44.0952L106.532 54.2686C107.303 55.0393 108.382 55.5017 109.307 55.5017C110.386 55.5017 111.311 55.0393 112.081 54.2686C113.623 52.7272 113.623 50.1067 112.081 48.5653L102.987 39.4709V18.5075C103.449 16.3495 101.754 14.4998 99.4416 14.4998Z",
    fill: "url(#paint3_linear_256_20035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_256_20035",
    x1: 0.63623,
    y1: 40.627,
    x2: 139.365,
    y2: 40.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02E3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA05D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_256_20035",
    x1: 0.63623,
    y1: 40.627,
    x2: 139.365,
    y2: 40.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02E3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA05D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_256_20035",
    x1: 0.63623,
    y1: 40.627,
    x2: 139.365,
    y2: 40.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02E3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA05D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_256_20035",
    x1: 0.63623,
    y1: 40.627,
    x2: 139.365,
    y2: 40.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02E3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA05D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.2225d867d295b19f6a8a851ff1180cdd.svg";
export { ForwardRef as ReactComponent };